<template>
  <el-footer>
    <div class="main-width footer-content">
      <div class="b-logo-list">
        <img src="@/assets/images/b_logo_1.png" alt="logo">
        <img src="@/assets/images/b_logo_2.png" alt="logo">
        <img src="@/assets/images/b_logo_3.png" alt="logo">
      </div>
      <div class="footer-right">
        <h2>联系我们</h2>
        <div class="footer-info">
          <div class="footer-info-list">
            <div class="footer-item">
              <span>电子邮件：</span><span>worldliterature@shisu.edu.cn</span>
            </div>
            <div class="footer-item">
              <span>来访地址：</span><span>上海外国语大学松江校区文翔路1550号 小别墅21号</span>
            </div>
            <div class="footer-item">
              <span>友情链接：</span>
              <div class="link">
                <a href="https://www.shisu.edu.cn/" target="_blank">上海外国语大学官网</a>
                <a href="http://www.saggas.shisu.edu.cn/" target="_blank">上海全球治理与区域国别研究院官网</a>
              </div>
            </div>
          </div>
          <div class="qr-img">
            <img src="@/assets/images/qr.png" alt="qr">
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copy">
      &copy; {{new Date().getFullYear()}}中国话语与世界文学研究中心 / Research Center for Chinese Discourse and World Literature
    </div>
  </el-footer>
</template>

<script>

export default {
  name: "",
  data() {
    return {
    }
  },
  props: {},
  components: {},
  mounted() { },
  methods: {},
}
</script>

<style lang="less">
.el-footer {
  height: 350px !important;
  background: #2960a7;
  margin-top: 40px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .footer-copy {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: rgba(0, 0, 0, 0.2);
    text-align: center;
    color: #c0c0c0;
  }
  .footer-content {
    height: 300px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .b-logo-list {
      display: flex;
      align-items: center;
      img {
        width: auto;
        height: 110px;
        object-fit: contain;
        & + img {
          margin-left: 26px;
        }
      }
    }
    .footer-right {
      width: calc(100% - 500px);
      h2 {
        font-weight: 500;
        font-size: 24px;
        line-height: 32px;
        color: #eee;
        padding: 12px 0;
        border-bottom: 1px solid #fff;
      }
      .footer-info {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 20px;
      }
      .footer-item {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        color: #eee;
        margin-bottom: 10px;
        span {
          line-height: 22px;
        }
        .link {
          display: block;
          line-height: 22px;
          a {
            display: block;
            color: #fff;
            line-height: 22px;
            margin-bottom: 10px;
            text-decoration: underline;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .el-footer {
    height: auto !important;
    margin-top: 30px;
    padding: 0 !important;
    .footer-copy {
      font-size: 10px;
      line-height: normal;
      height: auto;
      padding: 14px;
    }
    .footer-content {
      width: 100%;
      height: auto;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      padding: 24px 14px;
      .b-logo-list {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 14px;
        img {
          width: auto;
          height: calc((100vw - 28px) / 6);
          max-height: 110px;
          object-fit: cover;
          & + img {
            margin-left: 0;
          }
        }
      }
      .footer-right {
        width: 100%;
        margin-top: 14px;
        h2 {
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: #eee;
          padding: 8px 0;
          border-bottom: 1px solid #fff;
        }
        .footer-info {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          align-items: flex-start;
          margin-top: 14px;
        }
        .footer-item {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          color: #eee;
          margin-bottom: 8px;
          > span:first-child {
            width: 70px;
          }
          span {
            line-height: 22px;
            font-size: 12px;
          }
          .link {
            display: block;
            line-height: 22px;
            a {
              display: block;
              color: #fff;
              line-height: 22px;
              margin-bottom: 8px;
              text-decoration: underline;
              font-size: 12px;
            }
          }
        }
        .qr-img {
          width: 100%;
          margin-top: 20px;
          img {
            display: block;
            margin: 0 auto;
          }
        }
      }
    }
  }
}
</style>